import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import * as styles from './GuideDismissFooter.css';

type GuideDismissFooterProps = {
  onDismiss: () => void;
};

export const GuideDismissFooter = ({ onDismiss }: GuideDismissFooterProps) => {
  return (
    <button onClick={onDismiss} className={styles.footerContainer}>
      <span>I don't need this guide, dismiss</span>
      <FontAwesomeIcon icon={faXmark} className={styles.dismissIcon} />
    </button>
  );
};
